import { stepStatus } from "@/models/terminal.model";

const icons = new Map([
  ['description', 'mdi-file-document'],
  ['testgoal-document', 'mdi-file-document'],
  ['testgoal-edit-document', 'mdi-file-document-edit'],
  ['testcase-document', 'mdi-movie-open'],
  ['testcase-completed-document', 'mdi-movie-play'],
  ['testcase-edit-document', 'mdi-movie-open-edit'],
  ['testjob-document', 'mdi-flask-outline'],
  ['testjob-edit-document', 'mdi-flask-outline'],
  ['instruction-action', 'mdi-alpha-a'],
  ['instruction-checking', 'mdi-check'],
  ['param.required', 'mdi-alpha-r-circle'],
  ['param.optional', 'mdi-alpha-o-circle'],
  ['project-document', 'mdi-file-document-box'],
]);

export function appIcon(i: string): string | undefined {
  return icons.get(i);
}

export function reportStepIcon(checking: boolean, status: stepStatus) {
  const icons = checking
    ? ['mdi-alert', 'mdi-emoticon', 'mdi-emoticon-sad'] : ['mdi-alert', 'mdi-foot-print', 'mdi-alert']
  return icons[status as number]
}
